// Components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import StateContext from '../Contexts/StateContext';
import LoginRequired from '../Components/Common/LoginRequired';

export default function ProtectedRoute() {
    const GlobalState = useContext(StateContext);

    if (!GlobalState.userIsLogged) {
        return <LoginRequired />;
    }

    return <Outlet />;
}
